function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.87361 3.99992C5.42816 3.99992 5.20507 4.53849 5.52006 4.85347L7.64628 6.9797C7.84155 7.17496 8.15813 7.17496 8.35339 6.9797L10.4796 4.85347C10.7946 4.53849 10.5715 3.99992 10.1261 3.99992H5.87361Z",
  fill: "#233BC9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.87361 12.9998C5.42816 12.9998 5.20507 12.4613 5.52006 12.1463L7.64628 10.0201C7.84155 9.8248 8.15813 9.8248 8.35339 10.0201L10.4796 12.1463C10.7946 12.4613 10.5715 12.9998 10.1261 12.9998H5.87361Z",
  fill: "#233BC9"
});

function SvgArrowDoubleUnfold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoubleUnfold);
export default __webpack_public_path__ + "static/media/arrow_double_unfold.b710d251.svg";
export { ForwardRef as ReactComponent };